import { HashAlgorithm } from '@scayle/storefront-nuxt'
import { colorId } from './colors'
import type { SortingValueKey } from '#layers/base/utils/sort'
import type { OdoscopeSortingValueKey } from '#layers/base/utils/odoscopeSort'

export const defaultConfigs = {
  appKeys: {
    wishlistKey: 'aboutyou_customer_{userId}',
    basketKey: 'aboutyou_customer_{userId}',
    hashAlgorithm: HashAlgorithm.SHA256,
  },
}

export const colorConfig = {
  colorId,
}

export const DEFAULT_SORT_VALUE_KEY: SortingValueKey = 'topSeller'
export const DEFAULT_ODOSCOPE_SORT_VALUE_KEY: OdoscopeSortingValueKey =
  'labelDesc'
